module.exports = __webpack_public_path__ + "img/lunchly_menu3.279d7e82.png";